<div class='container-float'>

    <b-modal v-model="showModal" ref="delete" id="delete" title="Seleziona filtri" @ok="handleSearch" @cancel="handleCancel" size="lg">
        <b-card>

            <b-row class="mb-1">
                <b-col cols="6">
                    <select v-model="search.price_list_name" class="custom-select">
                        <option :value="null">-- Listino --</option>
                        <option v-for="(price_list, index) in prices_list" :value="price_list.price_list_name" :key="index">{{ price_list.price_list_name }}</option>
                    </select>
                </b-col>
                <b-col cols="6">
                    <select v-model="search.customer" class="custom-select">
                        <option :index="0" :value="null">-- Cliente --</option>
                        <option v-for="(customer, index) in customers_list" :value="customer.id" :key="index">{{ customer.company }}</option>
                    </select>
                </b-col>
            </b-row>

            <b-row class="mb-1">
                <b-col cols="6">
                    <select v-model="search.voice" class="custom-select">
                        <option :index="0" :value="null">-- Voce --</option>
                        <option v-for="(voice, index) in voices" :value="voice.id" :key="index">{{ voice.voice_name }}</option>
                    </select>
                </b-col>
                <b-col cols="6">
                    <select v-model="search.currency" class="custom-select">
                        <option :index="0" :value="null">-- Valuta --</option>
                        <option v-for="(currency, index) in currencies" :value="currency.id" :key="index">{{ currency.currency }}</option>
                    </select>
                </b-col>
            </b-row>

            <b-row class="mb-1">
                <b-col cols="6">
                    <select v-model="search.location" class="custom-select">
                        <option :index="0" :value="null">-- Locazione --</option>
                        <option v-for="(location, index) in locations" :value="location.id" :key="index">{{ location.location }}</option>
                    </select>
                </b-col>
                <b-col cols="6">
                    <select v-model="search.good_kind"  class="custom-select">
                        <option :index="0" :value="null">-- Tipo merce --</option>
                        <option v-for="(good_kind, index) in goods_kinds" :value="good_kind.id" :key="index">{{ good_kind.kind }}</option>
                    </select>
                </b-col>
            </b-row>

            <b-row class="mb-1">
                <b-col cols="6">
                    <b-form-input v-model="search.amount" placeholder="-- Importo unitario --"></b-form-input>
                </b-col>
                <b-col cols="6">
                    <b-form-input v-model="search.cost" placeholder="-- Costo unitario --"></b-form-input>
                </b-col>
            </b-row>

            <b-row class="mb-1">
                <b-col cols="6">
                    <select v-model="search.package_kind" class="custom-select">
                        <option :index="0" :value="null">-- Tipo imballaggio --</option>
                        <option v-for="(packaging_kind, index) in packaging_kinds" :value="packaging_kind.id" :key="index">{{ packaging_kind.description }}</option>
                    </select>
                </b-col>
                <b-col cols="6">
                    <select v-model="search.equipment_size" class="custom-select">
                        <option :index="0" :value="null">-- Dimensioni equipaggiamento --</option>
                        <option v-for="(equipment_size, index) in equipment_sizes" :value="equipment_size.id" :key="index">{{ equipment_size.size }}</option>
                    </select>
                </b-col>
            </b-row>

        </b-card>
    </b-modal>


    <b-row class="mb-3">
        <b-col cols="12">
            &nbsp;
        </b-col>
    </b-row>

    <b-alert v-model="showAlertMandatoryUnitAmount" variant="warning" dismissible>
        L'importo unitario è un parametro obbligatorio
    </b-alert>
    <b-alert v-model="showAlertMandatoryVoiceName" variant="warning" dismissible>
        Il nome della voce è un parametro obbligatorio
    </b-alert>
    <b-alert v-model="showAlertMandatoryPricesList" variant="warning" dismissible>
        Il listino prezzi è un parametro obbligatorio
    </b-alert>
    <b-alert v-model="showAlertMandatoryFormula" variant="warning" dismissible>
        La formula è un parametro obbligatorio
    </b-alert>

    <b-row class="mb-3">
        <b-col cols="12">

            <b-card
                    title="Voci di Listino"
            >
                <b-card-body style="text-align: left;">

                    <!-- Nome listino e nome cliente -->
                    <b-row>
                        <b-col cols='6'>
                            <div class='label'>Listino</div>
                        </b-col>
                        <b-col cols='6'>
                            <div class='label'>Cliente</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='6'>
                            <b-form-input v-model="row.price_list_name" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='6'>
                            <select
                                    class="custom-select"
                                    v-model="selectedCustomer"
                            >
                                <option></option>
                                <option
                                        v-for="customer in customers_list"
                                        :key="customer.id"
                                        :value="customer.id"
                                >
                                    {{ customer.company }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- Nome della voce e unita' di misura -->
                    <b-row>
                        <b-col cols='6'>
                            <div class='label'>Nome della voce</div>
                        </b-col>
                        <b-col cols='6'>
                            <div class='label'>Unità di misura</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='6'>
                            <b-form-input v-model="row.voice_name" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='6'>
                            <select
                                    class="custom-select"
                                    v-model="selectedUM"
                            >
                                <option></option>
                                <option
                                        v-for="measure_unit in measure_units"
                                        :key="measure_unit.id"
                                        :value="measure_unit.id"
                                >
                                    {{ measure_unit.measure_unit }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- Valuta, data inizio e data fine validità -->
                    <b-row>
                        <b-col cols='4'>
                            <div class='label'>Valuta</div>
                        </b-col>
                        <b-col cols='4'>
                            <div class='label'>Data inizio validità</div>
                        </b-col>
                        <b-col cols='4'>
                            <div class='label'>Data fine validità</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='4'>
                            <select
                                    class="custom-select"
                                    v-model="selectedCurrency"
                            >
                                <option></option>
                                <option
                                        v-for="currency in currencies"
                                        :key="currency.id"
                                        :value="currency.id"
                                >
                                    {{ currency.currency }}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols='4'>
                            <div class="d-flex mb-2" style="">
                                <Datepicker
                                        v-model="row.start_date"
                                        :teleport="true"
                                        :input-class="'custom-input'"
                                        :icon-class="'custom-icon'"
                                        :format="dateFormat"
                                        :locale="locale"
                                        :show-cancel-btn=false
                                        :show-select-btn= false
                                        :enable-time-picker= false
                                        :auto-apply= "true"
                                />
                            </div>
                        </b-col>
                        <b-col cols='4'>
                            <div class="d-flex mb-2" style="">
                                <Datepicker
                                        v-model="row.end_date"
                                        :teleport="true"
                                        :input-class="'custom-input'"
                                        :icon-class="'custom-icon'"
                                        :format="dateFormat"
                                        :locale="locale"
                                        :show-cancel-btn=false
                                        :show-select-btn= false
                                        :enable-time-picker= false
                                        :auto-apply= "true"
                                />
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Locazione 1 e Locazione 2 -->
                    <b-row>
                        <b-col cols='6'>
                            <div class='label'>Locazione 1</div>
                        </b-col>
                        <b-col cols='6'>
                            <div class='label'>Locazione 2</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='6'>
                            <select
                                    class="custom-select"
                                    v-model="selectedLocationId1"
                            >
                                <option></option>
                                <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.location }}</option>
                            </select>
                        </b-col>
                        <b-col cols='6'>
                            <select
                                    class="custom-select"
                                    v-model="selectedLocationId2"
                            >
                                <option></option>
                                <option v-for="location in locations" :key="location.id" :value="location.id">{{ location.location }}</option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- Base -->
                    <b-row>
                        <b-col cols='12'>
                            <div class='label'>Base</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='12'>
                            <select
                                    class="custom-select"
                                    v-model="selectedBase"
                            >
                                <option></option>
                                <option
                                        v-for="base in bases"
                                        :key="base.id"
                                        :value="base.id"
                                >
                                    {{ base.base_code }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- Scaglione minimo e massimo e uita' di misura-->
                    <b-row>
                        <b-col cols='5'>
                            <div class='label'>Scaglione minimo</div>
                        </b-col>
                        <b-col cols='5'>
                            <div class='label'>Scaglione massimo</div>
                        </b-col>
                        <b-col cols='2'>
                            <div class='label'>Unità di misura dello scaglione</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='5'>
                            <b-form-input v-model="row.lower_end_bracket" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='5'>
                            <b-form-input v-model="row.upper_end_bracket" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='2'>
                            <select
                                    class="custom-select"
                                    v-model="selectedBracketMeasureUnit"
                            >
                                <option></option>
                                <option
                                        v-for="bracket_measure_unit in bracket_measure_units"
                                        :key="bracket_measure_unit.id"
                                        :value="bracket_measure_unit.id"
                                >
                                    {{ bracket_measure_unit.measure_unit }}
                                </option>
                            </select>
                        </b-col>
                    </b-row>

                    <!-- Formula, importo e costo unitario -->
                    <b-row>
                        <b-col cols='8'>
                            <div class='label'>Formula</div>
                        </b-col>
                        <b-col cols='2'>
                            <div class='label'>Importo unitario</div>
                        </b-col>
                        <b-col cols='2'>
                            <div class='label'>Costo unitario</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='8'>
                            <select
                                    class="custom-select"
                                    v-model="selectedCalculationFormula"
                            >
                                <option></option>
                                <option
                                        v-for="calculation_formula in calculation_formulas"
                                        :key="calculation_formula.id"
                                        :value="calculation_formula.id"
                                >
                                    {{ calculation_formula.formula }}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols='2'>
                            <b-form-input v-model="row.unit_amount" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='2'>
                            <b-form-input v-model="row.unit_cost" class="custom-input"></b-form-input>
                        </b-col>
                    </b-row>

                    <!-- valore minimo, voce attiva, voce passiva, -->
                    <b-row>
                        <b-col cols='2'>
                            <div class='label'>Valore minimo</div>
                        </b-col>
                        <b-col cols='5'>
                            <div class='label'>Voce attiva</div>
                        </b-col>
                        <b-col cols='5'>
                            <div class='label'>Voce passiva</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='2'>
                            <b-form-input v-model="row.minimal_amount" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='5'>
                            <b-form-input v-model="row.active_voice" class="custom-input"></b-form-input>
                        </b-col>
                        <b-col cols='5'>
                            <b-form-input v-model="row.passive_voice" class="custom-input"></b-form-input>
                        </b-col>
                    </b-row>

                    <!--tipo merce, tipo imballaggio, dimensioni equipaggiamento -->
                    <b-row>
                        <b-col cols='4'>
                            <div class='label'>Tipologia merce</div>
                        </b-col>
                        <b-col cols='4'>
                            <div class='label'>Tipologia imballaggio</div>
                        </b-col>
                        <b-col cols='4'>
                            <div class='label'>Dimensioni equipaggiamento</div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='4'>
                            <select
                                    class="custom-select"
                                    v-model="selectedGoodsKind"
                            >
                                <option></option>
                                <option
                                        v-for="good_kind in goods_kinds"
                                        :key="good_kind.id"
                                        :value="good_kind.id"
                                >
                                    {{ good_kind.kind }}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols='4'>
                            <select
                                    class="custom-select"
                                    v-model="selectedPackagingKind"
                            >
                                <option></option>
                                <option
                                        v-for="packaging_kind in packaging_kinds"
                                        :key="packaging_kind.id"
                                        :value="packaging_kind.id"
                                >
                                    {{ packaging_kind.description }}
                                </option>
                            </select>
                        </b-col>
                        <b-col cols='4'>
                            <b-form-input v-model="row.equipment_size" class="custom-input"></b-form-input>
                        </b-col>
                    </b-row>

                    <!-- Separator -->
                    <b-row>
                        <b-col cols='12'>
                            &nbsp;
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='2'>
                            <b-button variant="outline-warning" @click="clearInput">Pulisci</b-button>
                        </b-col>
                        <b-col cols='2'>
                            &nbsp;
                        </b-col>
                        <b-col cols='3'>
                            <b-button-group>
                                <b-button class="button" variant="outline-danger" @click="deleteRow">&nbsp;&nbsp;&nbsp;Cancella righe selezionate&nbsp;&nbsp;&nbsp;</b-button>
                                <b-button class="button" variant="outline-success" @click="filterRows">&nbsp;&nbsp;&nbsp;Filtra&nbsp;&nbsp;&nbsp;</b-button>
                            </b-button-group>
                        </b-col>
                        <b-col cols='3'>
                            &nbsp;
                        </b-col>
                        <b-col cols='2'>
                            <b-button-group>
                                <b-button class='button' variant="warning" @click="cancelPriceList">&nbsp;&nbsp;&nbsp;Annulla&nbsp;&nbsp;&nbsp;</b-button>
                                <b-button class="button" v-if="edit" variant="success" @click="updatePriceList">&nbsp;&nbsp;&nbsp;Modifica&nbsp;&nbsp;&nbsp;</b-button>
                                <b-button class="button" v-if="!edit" variant="primary" @click="savePriceList">&nbsp;&nbsp;&nbsp;Salva&nbsp;&nbsp;&nbsp;</b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols='12'>
                            &nbsp;
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols='12'>
                            <PriceListGrid
                                    ref="priceListGrid"
                                    @row-selected="handleRowSelected"
                                    @items-rows-selected="handleActions"
                                    :selected-name="selectedName"
                                    :search="search"
                            >
                            </PriceListGrid>
                        </b-col>
                    </b-row>
                    <!--
                    -->
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</div>















